import React from 'react';

export type AiOrbAgent = 'kate' | 'rex' | 'travis' | 'finance';

interface IProps {
    agent?: AiOrbAgent | null;
    /** Additional CSS classes */
    className?: string;
    /** Whether to show the pulse ring animation */
    animated?: boolean;
}

const ORB_GRADIENT: Record<string, string> = {
    kate: 'radial-gradient(62.27% 62.27% at 37.5% 37.5%, #EAE6FF 0%, #A48CFF 50%, #7B61FF 100%)',
    rex: 'radial-gradient(62.27% 62.27% at 37.5% 37.5%, #FFF3E8 0%, #FFBF75 50%, #F97316 100%)',
    travis: 'radial-gradient(62.27% 62.27% at 37.5% 37.5%,#E6F8EC 0%,#5FCF8B 50%,#179044 100%)',
    finance: 'radial-gradient(62.27% 62.27% at 37.5% 37.5%,#EAF4FF 0%,#7DBBFF 50%,#3B82F6 100%)',
    none: 'radial-gradient(62.27% 62.27% at 37.5% 37.5%, #F5F5F4 0%, #BDC3D1 50%, #888FA1 100%)',
};

const ORB_SHADOW: Record<string, string> = {
    kate: '0 2px 8px 0 rgba(123, 97, 255, 0.40), 0 2px 10px 0 rgba(123, 97, 255, 0.20)',
    rex: '0 2px 8px 0 rgba(249, 115, 22, 0.40), 0 2px 10px 0 rgba(249, 115, 22, 0.20)',
    travis: '0 2px 8px 0 rgba(123,97,255,0.40),0 2px 10px 0 rgba(123,97,255,0.20)',
    finance: '0 2px 8px 0 rgba(59,130,246,0.40),0 2px 10px 0 rgba(59,130,246,0.20)',
    none: '0 2px 8px 0 rgba(136, 143, 161, 0.40), 0 2px 10px 0 rgba(136, 143, 161, 0.20)',
};

const ORB_RING_COLOR: Record<string, string> = {
    kate: '#7B61FF',
    rex: '#F97316',
    travis: '#179044',
    finance: '#3B82F6',
    none: '#888FA1',
};

const AiOrb = ({ agent, className = '', animated = false }: IProps) => {
    const key = agent ?? 'none';

    return (
        <div
            className={`rounded-full w-3.5 h-3.5 flex-shrink-0 ${animated ? 'orb-animation' : ''} ${className}`.trim()}
            style={
                {
                    background: ORB_GRADIENT[key],
                    boxShadow: ORB_SHADOW[key],
                    '--orb-ring-color': ORB_RING_COLOR[key],
                } as React.CSSProperties
            }
        />
    );
};

export default AiOrb;
